import { SSCarouselResult } from '../../search-spring/types/types'
import { PRICE_ON_APPLICATION_LABEL, formatDollars, isPriceOnApplication } from '../../helpers/formatMoney'
import { type_GM_STATE } from '../../helpers'
import { postBeaconTracking, redirect, generateBeaconClick, generateBeaconProductClick } from '../../helpers/searchspring-tracking'

declare var GM_STATE: type_GM_STATE
type Props = {
  product: SSCarouselResult
  profile: string,
  sku: string
}

const CarouselCard = ({ product, profile }: Props): JSX.Element | null => {
  if (!product) return null
  const { defaultImage } = GM_STATE.shopify
  const imageUrl = product.attributes.image ? product.attributes.image : defaultImage
  const hasFromLabel = product.attributes.ss_tags.includes('FROM') || product.attributes.ss_tags.includes('from') || product.attributes.tags.includes('Template_Same Pair')
  const shouldShowPriceOnApplication = isPriceOnApplication(product.mappings.core.price, product.attributes.tags)
  const showCompareAtPrice = Number(product.mappings.core.msrp) > Number(product.mappings.core.price) && !shouldShowPriceOnApplication
  const currentPriceText = shouldShowPriceOnApplication
    ? PRICE_ON_APPLICATION_LABEL
    : `${hasFromLabel ? 'FROM ' : ''}${formatDollars(Number(product.mappings.core.price))}`
  const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
  const productUrl = product.mappings.core.url
  const productUrlWithLocale = !rootUrlWithoutSlash || (rootUrlWithoutSlash && productUrl.includes(rootUrlWithoutSlash))
    ? productUrl
    : rootUrlWithoutSlash + productUrl

  const handleClickTracking = async (e: any) => {
    e.preventDefault()
    const beaconClickTracking = [generateBeaconClick(product, profile, 'profile.click'), generateBeaconProductClick(product, profile, 'profile.product.click', null)]

    if (beaconClickTracking) {
      const result = await postBeaconTracking(beaconClickTracking)

      if (result) {
        window.location.href = productUrlWithLocale
        redirect(productUrlWithLocale, e.ctrlKey)
      }
    } else {
      redirect(productUrlWithLocale, e.ctrlKey)
    }
  }

  return (
    <div className="group relative">
      <a href={productUrlWithLocale} className="block relative w-full h-auto" title={product.mappings.core.name} onClick={handleClickTracking}>
        <img src={`${imageUrl}&width=1200`} width="auto" height="auto" alt={product.mappings.core.name} className="w-full h-auto object-cover aspect-[170/212] lg:aspect-[335/419]" loading="lazy" />
        {product.attributes.ss_image_hover && (
          <img
            src={product.attributes.ss_image_hover}
            alt={`${product.mappings.core.name} hover`}
            width="auto"
            height="auto"
            loading="lazy"
            className="w-full h-auto absolute top-0 left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-[350ms] ease-in-out md-max:hidden object-cover aspect-[170/212] lg:aspect-[335/419]"
          />
        )}
      </a>

      <div className="relative flex flex-col">
        <div
          className={`flex flex-col mt-XS transition-opacity duration-[350ms] ease-in-out ${
            product?.attributes?.mfield_custom_product_bi_line ? 'md:group-hover:opacity-0' : ''
          }`}
        >
          <a href={productUrlWithLocale} onClick={handleClickTracking}>
            <h3 className="uppercase font-bstSpyre tracking-[1%] text-[12px] md:text-[14px] leading-[150%] md:leading-[120%] text-base-2">{product.mappings.core.name}</h3>
          </a>
          <div className="mt-XS flex justify-between gap-2.5">
            <div className="flex justify-start gap-1">
              {showCompareAtPrice ? (
                <>
                  <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                    {currentPriceText}
                  </p>
                  <p className="font-calibre uppercase line-through opacity-40 tracking-[4%] text-[12px] leading-[120%]">
                    {formatDollars(Number(product.mappings.core.msrp))}
                  </p>
                </>
              ) : (
                <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                  {currentPriceText}
                </p>
              )}
            </div>
          </div>
        </div>
        {product.attributes?.mfield_custom_product_bi_line && (
          <div className="absolute top-0 left-0 w-full transition-opacity duration-[350ms] ease-in-out opacity-0 group-hover:opacity-100 md-max:hidden">
            <div className="flex align-baseline justify-between gap-2.5 w-full mt-XS">
              <a href={productUrlWithLocale} onClick={handleClickTracking}>
                <h3 className="font-bstSpyre text-base-2">{product.attributes.mfield_custom_product_bi_line}</h3>
              </a>
            </div>

            <div className="mt-XS flex justify-start gap-1">
              {showCompareAtPrice ? (
                <>
                  <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                    {currentPriceText}
                  </p>
                  <p className="font-calibre uppercase line-through opacity-40 tracking-[4%] text-[12px] leading-[120%]">
                    {formatDollars(Number(product.mappings.core.msrp))}
                  </p>
                </>
              ) : (
                <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                  {currentPriceText}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CarouselCard
